import {TranslationObject} from '@colonist/i18n'
import {SharedStrings} from '@colonist/types'
import {UIPopupController} from '../../../../shared/scripts/ui_popup/UIPopupController'
import {captureMessage} from '@sentry/browser'
import {DiscordContentFrameCommunicationHandler} from './DiscordContentFrameCommunicationHandler'
import {DiscordMountPopupType} from '../../../../../shared/DiscordActivityTypes'

export class DiscordPopupFromMountHandler {
    private readonly contentFrameCommunicationHandler: DiscordContentFrameCommunicationHandler

    constructor(contentFrameCommunicationHandler: DiscordContentFrameCommunicationHandler) {
        this.contentFrameCommunicationHandler = contentFrameCommunicationHandler
    }

    createPopup(data: Record<string, any> | undefined) {
        if(data?.popupType == undefined) throw new Error('Popup type is missing')

        const popupType = data.popupType as DiscordMountPopupType
        switch(popupType) {
            case DiscordMountPopupType.UserAlreadyHasMembershipError: this.createUserAlreadyHasMembershipError(data); break
            default: return
        }
    }

    private createUserAlreadyHasMembershipError(data: Record<string, any>) {
        if(data.error == undefined) return

        const alreadyHasMembershipTitle: TranslationObject = {key: 'strings:popups.errors.discordActiveMembershipError.title'}
        const alreadyHasMembershipBody: TranslationObject = {
            key: 'strings:popups.errors.discordActiveMembershipError.body',
            options: {
                discordLink: SharedStrings.DISCORD_CHANNEL,
            },
        }
        UIPopupController.createSimplePopup(alreadyHasMembershipTitle, alreadyHasMembershipBody)

        this.sendUserAlreadyHasMembershipReportToSentry(data.error)
    }

    private sendUserAlreadyHasMembershipReportToSentry(error: any) {
        const data = {
            discordUsername: this.contentFrameCommunicationHandler.serverProfile?.username ?? 'unknown username',
            errorCode: error.code,
            errorMessage: error.message,
        }

        captureMessage(`Discord Error | ${error.message}`, {
            level: 'error',
            extra: {
                data: JSON.stringify(data),
            },
        })
    }
}
